import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ServerConfigService } from '../../../../services/server-config.service';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';

@Component({
    selector: 'lex-server-config',
    templateUrl: './server-config.component.html',
    styleUrls: ['./server-config.component.scss'],
    standalone: false
})
export class ServerConfigComponent implements OnInit {

  buttonClickSubject = new Subject<boolean>();
  searchControl = new UntypedFormControl('');
  filteredConfigs$;
  dirty = false;
  isSearch: boolean = false;
  @ViewChild('searchBox') searchBoxElement: ElementRef;

  constructor(private service: ServerConfigService) { }

  ngOnInit(): void {
    const searchString$ = this.searchControl.valueChanges.pipe(
      startWith(''),
      debounceTime(100),
      distinctUntilChanged()
    );
	const serverConfigs$ = this.service.getServerConfigs();

    this.filteredConfigs$ = combineLatest(serverConfigs$, searchString$).pipe(
      map(([serverConfigs, searchString]) => {
        if (searchString) {
          return serverConfigs.filter(sc => sc.name.toLowerCase().includes(searchString.toLowerCase()));
        }
        return serverConfigs;
      })
    );
  }

  saveAll() {
    this.buttonClickSubject.next(true);
    this.dirty = false;
  }

  cancelAll() {
    this.buttonClickSubject.next(false);
    this.dirty = false;
  }

  showSearch(): void {
    this.isSearch = !this.isSearch;
    if (!this.isSearch) return;
    setTimeout(() => {
      // This will make the execution after the above boolean has changed
      this.searchBoxElement.nativeElement.focus();
    }, 0);
  }
}
